const MainMenu = [
  {
    title: "Upload new transcript",
    path: "/",
  },
  {
    title: "My transcripts",
    path: "/transcripts",
  },
];

const FooterMenu = [
  {
    title: "About Transcript app",
    path: "/about",
  },
  {
    title: "Credits",
    path: "/credits",
  },
];

const Menus = {
  MainMenu,
  FooterMenu,
};

export default Menus;
